import { useState } from 'react';

type SummaryItem = {
  id: string;
  name: string;
};

export function useSummary() {
  const [summary, setSummary] = useState<Array<SummaryItem>>([]);

  function summarizer() {
    const subtitles = document.getElementsByTagName('h2');

    const summaryItems = Array.from(subtitles).map((subtitle: HTMLHeadingElement) => {
      const id = subtitle.textContent ? subtitle.textContent.replace(/\s/g, '-') : '';
      subtitle.id = id;
      return {
        id: id,
        name: subtitle.textContent ?? '',
      };
    });
    delete summaryItems[
      summaryItems.findIndex((item: SummaryItem) => item?.name === 'VOCÊ TAMBÉM PODE SE INTERESSAR POR:')
    ];
    delete summaryItems[
      summaryItems.findIndex((item: SummaryItem) => item?.name === 'ASSUNTOS MAIS RELEVANTES:')
    ];
    setSummary(summaryItems);
  }

  return { summarizer, summary };
}
